module.exports = __webpack_public_path__ + "img/4-2.09664b07.png";